export default "__VITE_ASSET__B7jEivhF__"